import React, { Component } from 'react';

import { connect } from 'react-redux';
import { getFormValues, change as onChange } from 'redux-form';
import {
  List,
  ListItem,
  Toggle,
  Divider,
  SelectField,
  MenuItem,
} from 'material-ui';
import moment from 'moment';
import _ from 'lodash';

import './style.css';

import timezones from './timezones';
import { TranslatableInput } from '../blocks/inputs/TranslatableInput';

const selector = getFormValues('record-form');

const days = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

class OpenHoursBuilder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      configuration: {
        weekSchedule: {
          monday: null,
          tuesday: null,
          wednesday: null,
          thursday: null,
          friday: null,
          saturday: null,
          sunday: null,
          ..._.get(props, `record.openHours.${props.type}.weekSchedule`),
        },
        ..._.get(props, `record.openHours.${props.type}`),
      },
    };
  }

  change = (key, value) => {
    this.setState(
      (state) => _.set(state, key, value),
      () =>
        this.props.change(
          'record-form',
          `openHours.${this.props.type}`,
          this.state.configuration
        )
    );
  };

  render = () => {
    const { locale, translate, type } = this.props;
    moment.locale('en');

    const { configuration } = this.state;

    return (
      <div>
        <SelectField
          floatingLabelText={translate('timezone')}
          value={_.get(configuration, 'timezone')}
        >
          {timezones.map((tz) => (
            <MenuItem primaryText={tz} value={tz} />
          ))}
        </SelectField>
        <TranslatableInput
          label={translate('comment')}
          id={`comment-${type}`}
          values={configuration.comment}
          onChange={(val) => this.change('configuration.comment', val)}
          options={{ multiline: true }}
        />
        <List>
          {days.map((dayName) => {
            const translatedDayName = moment(dayName, 'dddd')
              .locale(locale)
              .format('dddd');
            const day = _.get(configuration, `weekSchedule.${dayName}`);
            return (
              <React.Fragment key={dayName}>
                <ListItem
                  key={dayName}
                  disabled
                  primaryText={
                    <section>
                      <div className="toggles">
                        <h4>{translatedDayName}</h4>
                        <Toggle
                          name="open"
                          label={translate('open')}
                          onToggle={(e, value) => {
                            if (value) {
                              return this.change(
                                `configuration.weekSchedule.${dayName}`,
                                ['16:00', '22:00']
                              );
                            }
                            return this.change(
                              `configuration.weekSchedule.${dayName}`,
                              null
                            );
                          }}
                          toggled={day}
                        />
                      </div>
                      <div className="dropdowns">
                        <SelectField
                          name="startTime"
                          disabled={!day}
                          required
                          floatingLabelText={translate('openingHour')}
                          value={day && day[0]}
                          onChange={(e, i, value) =>
                            this.change(
                              `configuration.weekSchedule.${dayName}.0`,
                              value
                            )
                          }
                        >
                          <MenuItem
                            key="07:00"
                            primaryText="07:00"
                            value="07:00"
                          />
                          <MenuItem
                            key="07:30"
                            primaryText="07:30"
                            value="07:30"
                          />
                          <MenuItem
                            key="08:00"
                            primaryText="08:00"
                            value="08:00"
                          />
                          <MenuItem
                            key="08:30"
                            primaryText="08:30"
                            value="08:30"
                          />
                          <MenuItem
                            key="09:00"
                            primaryText="09:00"
                            value="09:00"
                          />
                          <MenuItem
                            key="09:30"
                            primaryText="09:30"
                            value="09:30"
                          />
                          <MenuItem
                            key="10:00"
                            primaryText="10:00"
                            value="10:00"
                          />
                          <MenuItem
                            key="10:30"
                            primaryText="10:30"
                            value="10:30"
                          />
                          <MenuItem
                            key="11:00"
                            primaryText="11:00"
                            value="11:00"
                          />
                          <MenuItem
                            key="11:30"
                            primaryText="11:30"
                            value="11:30"
                          />
                          <MenuItem
                            key="12:00"
                            primaryText="12:00"
                            value="12:00"
                          />
                          <MenuItem
                            key="12:30"
                            primaryText="12:30"
                            value="12:30"
                          />
                          <MenuItem
                            key="13:00"
                            primaryText="13:00"
                            value="13:00"
                          />
                          <MenuItem
                            key="13:30"
                            primaryText="13:30"
                            value="13:30"
                          />
                          <MenuItem
                            key="14:00"
                            primaryText="14:00"
                            value="14:00"
                          />
                          <MenuItem
                            key="14:30"
                            primaryText="14:30"
                            value="14:30"
                          />
                          <MenuItem
                            key="15:00"
                            primaryText="15:00"
                            value="15:00"
                          />
                          <MenuItem
                            key="15:30"
                            primaryText="15:30"
                            value="15:30"
                          />
                          <MenuItem
                            key="16:00"
                            primaryText="16:00"
                            value="16:00"
                          />
                          <MenuItem
                            key="16:30"
                            primaryText="16:30"
                            value="16:30"
                          />
                          <MenuItem
                            key="17:00"
                            primaryText="17:00"
                            value="17:00"
                          />
                          <MenuItem
                            key="17:30"
                            primaryText="17:30"
                            value="17:30"
                          />
                          <MenuItem
                            key="18:00"
                            primaryText="18:00"
                            value="18:00"
                          />
                          <MenuItem
                            key="18:30"
                            primaryText="18:30"
                            value="18:30"
                          />
                          <MenuItem
                            key="19:00"
                            primaryText="19:00"
                            value="19:00"
                          />
                          <MenuItem
                            key="19:30"
                            primaryText="19:30"
                            value="19:30"
                          />
                          <MenuItem
                            key="20:00"
                            primaryText="20:00"
                            value="20:00"
                          />
                          <MenuItem
                            key="20:30"
                            primaryText="20:30"
                            value="20:30"
                          />
                          <MenuItem
                            key="21:00"
                            primaryText="21:00"
                            value="21:00"
                          />
                          <MenuItem
                            key="21:30"
                            primaryText="21:30"
                            value="21:30"
                          />
                          <MenuItem
                            key="22:00"
                            primaryText="22:00"
                            value="22:00"
                          />
                          <MenuItem
                            key="22:30"
                            primaryText="22:30"
                            value="22:30"
                          />
                          <MenuItem
                            key="23:00"
                            primaryText="23:00"
                            value="23:00"
                          />
                          <MenuItem
                            key="23:30"
                            primaryText="23:30"
                            value="23:30"
                          />
                          <MenuItem
                            key="00:00"
                            primaryText="00:00"
                            value="00:00"
                          />
                        </SelectField>
                        <SelectField
                          name="endTime"
                          disabled={!day}
                          required
                          floatingLabelText={translate('closingHour')}
                          value={day && day[1]}
                          onChange={(e, i, value) =>
                            this.change(
                              `configuration.weekSchedule.${dayName}.1`,
                              value
                            )
                          }
                        >
                          <MenuItem
                            key="07:00"
                            primaryText="07:00"
                            value="07:00"
                          />
                          <MenuItem
                            key="07:30"
                            primaryText="07:30"
                            value="07:30"
                          />
                          <MenuItem
                            key="08:00"
                            primaryText="08:00"
                            value="08:00"
                          />
                          <MenuItem
                            key="08:30"
                            primaryText="08:30"
                            value="08:30"
                          />
                          <MenuItem
                            key="09:00"
                            primaryText="09:00"
                            value="09:00"
                          />
                          <MenuItem
                            key="09:30"
                            primaryText="09:30"
                            value="09:30"
                          />
                          <MenuItem
                            key="10:00"
                            primaryText="10:00"
                            value="10:00"
                          />
                          <MenuItem
                            key="10:30"
                            primaryText="10:30"
                            value="10:30"
                          />
                          <MenuItem
                            key="11:00"
                            primaryText="11:00"
                            value="11:00"
                          />
                          <MenuItem
                            key="11:30"
                            primaryText="11:30"
                            value="11:30"
                          />
                          <MenuItem
                            key="12:00"
                            primaryText="12:00"
                            value="12:00"
                          />
                          <MenuItem
                            key="12:30"
                            primaryText="12:30"
                            value="12:30"
                          />
                          <MenuItem
                            key="13:00"
                            primaryText="13:00"
                            value="13:00"
                          />
                          <MenuItem
                            key="13:30"
                            primaryText="13:30"
                            value="13:30"
                          />
                          <MenuItem
                            key="14:00"
                            primaryText="14:00"
                            value="14:00"
                          />
                          <MenuItem
                            key="14:30"
                            primaryText="14:30"
                            value="14:30"
                          />
                          <MenuItem
                            key="15:00"
                            primaryText="15:00"
                            value="15:00"
                          />
                          <MenuItem
                            key="15:30"
                            primaryText="15:30"
                            value="15:30"
                          />
                          <MenuItem
                            key="16:00"
                            primaryText="16:00"
                            value="16:00"
                          />
                          <MenuItem
                            key="16:30"
                            primaryText="16:30"
                            value="16:30"
                          />
                          <MenuItem
                            key="17:00"
                            primaryText="17:00"
                            value="17:00"
                          />
                          <MenuItem
                            key="17:30"
                            primaryText="17:30"
                            value="17:30"
                          />
                          <MenuItem
                            key="18:00"
                            primaryText="18:00"
                            value="18:00"
                          />
                          <MenuItem
                            key="18:30"
                            primaryText="18:30"
                            value="18:30"
                          />
                          <MenuItem
                            key="19:00"
                            primaryText="19:00"
                            value="19:00"
                          />
                          <MenuItem
                            key="19:30"
                            primaryText="19:30"
                            value="19:30"
                          />
                          <MenuItem
                            key="20:00"
                            primaryText="20:00"
                            value="20:00"
                          />
                          <MenuItem
                            key="20:30"
                            primaryText="20:30"
                            value="20:30"
                          />
                          <MenuItem
                            key="21:00"
                            primaryText="21:00"
                            value="21:00"
                          />
                          <MenuItem
                            key="21:30"
                            primaryText="21:30"
                            value="21:30"
                          />
                          <MenuItem
                            key="22:00"
                            primaryText="22:00"
                            value="22:00"
                          />
                          <MenuItem
                            key="22:30"
                            primaryText="22:30"
                            value="22:30"
                          />
                          <MenuItem
                            key="23:00"
                            primaryText="23:00"
                            value="23:00"
                          />
                          <MenuItem
                            key="23:30"
                            primaryText="23:30"
                            value="23:30"
                          />
                          <MenuItem
                            key="00:00"
                            primaryText="00:00"
                            value="00:00"
                          />
                          <MenuItem
                            key="late"
                            primaryText={translate('late')}
                            value="late"
                          />
                        </SelectField>
                      </div>
                    </section>
                  }
                />
                <Divider />
              </React.Fragment>
            );
          })}
        </List>
      </div>
    );
  };
}

export default connect((state) => ({ record: selector(state) }), {
  change: onChange,
})(OpenHoursBuilder);
